var _Defs, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Defs, G, Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: style */
function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    id: "calendar_svg__Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 23"
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null)), _G || (_G = /*#__PURE__*/React.createElement(G, {
    id: "calendar_svg__News_-_All",
    "data-name": "News - All"
  }, /*#__PURE__*/React.createElement(Path, {
    className: "calendar_svg__cls-1",
    d: "M18 2h-2V1c0-.55-.45-1-1-1s-1 .45-1 1v1H7V1c0-.55-.45-1-1-1S5 .45 5 1v1H3C1.35 2 0 3.35 0 5v15c0 1.65 1.35 3 3 3h15c1.65 0 3-1.35 3-3V5c0-1.65-1.35-3-3-3zm2 18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h2v1c0 .55.45 1 1 1s1-.45 1-1V3h7v1c0 .55.45 1 1 1s1-.45 1-1V3h2c1.1 0 2 .9 2 2v15z"
  }), /*#__PURE__*/React.createElement(Path, {
    className: "calendar_svg__cls-1",
    d: "M3 7h3v3H3zM9 7h3v3H9zM15 7h3v3h-3zM3 12h3v3H3zM9 12h3v3H9zM15 12h3v3h-3zM3 17h3v3H3zM9 17h3v3H9zM15 17h3v3h-3z"
  }))));
}
export default SvgCalendar;